import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vuejs': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M356.9 64.3h91.1l-224 383.7-224-383.7h176l48 88.6 56-88.6h76.9zM55.7 96.3l168.3 288.2 168.2-288.2h-53.8l-114.4 198.2-114.5-198.2h-53.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vuejs.js
// module id = 1086
// module chunks = 0